import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper } from 'components';
import { dateTimeFormat } from 'enums';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var externalCreditHistoryTypeName = {
  payment: 'Плащане'
};

var formatHistoryData = function formatHistoryData(data) {
  try {
    var _parsed$old_last_paym, _parsed$new_last_paym, _parsed$old_last_paym2, _parsed$new_last_paym2, _parsed$old_status, _parsed$new_status;

    var parsed = typeof data === 'string' ? JSON.parse(data) : data;
    var changes = [];
    if (parsed.old_last_payment_date !== parsed.new_last_payment_date) changes.push("\u0414\u0430\u0442\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043F\u043B\u0430\u0449\u0430\u043D\u0435: ".concat((_parsed$old_last_paym = parsed.old_last_payment_date) !== null && _parsed$old_last_paym !== void 0 ? _parsed$old_last_paym : '--', " -> ").concat((_parsed$new_last_paym = parsed.new_last_payment_date) !== null && _parsed$new_last_paym !== void 0 ? _parsed$new_last_paym : '--'));
    if (parsed.old_last_payment_amount !== parsed.new_last_payment_amount) changes.push("\u0421\u0443\u043C\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u043F\u043B\u0430\u0449\u0430\u043D\u0435: ".concat((_parsed$old_last_paym2 = parsed.old_last_payment_amount) !== null && _parsed$old_last_paym2 !== void 0 ? _parsed$old_last_paym2 : '--', " -> ").concat((_parsed$new_last_paym2 = parsed.new_last_payment_amount) !== null && _parsed$new_last_paym2 !== void 0 ? _parsed$new_last_paym2 : '--'));
    if (parsed.old_status !== parsed.new_status) changes.push("\u0421\u0442\u0430\u0442\u0443\u0441: ".concat((_parsed$old_status = parsed.old_status) !== null && _parsed$old_status !== void 0 ? _parsed$old_status : '--', " -> ").concat((_parsed$new_status = parsed.new_status) !== null && _parsed$new_status !== void 0 ? _parsed$new_status : '--'));
    return changes.length > 0 ? changes.join(', ') : '--';
  } catch (_unused) {
    return data !== null && data !== void 0 ? data : '--';
  }
};

var ExternalCreditHistoryTab = function ExternalCreditHistoryTab(_ref) {
  var history = _ref.history;
  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref2) {
      var css = _ref2.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u0441\u0442\u043E\u0440\u0438\u044F"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX("div", {
    css: list
  }, (history === null || history === void 0 ? void 0 : history.length) > 0 ? ___EmotionJSX("table", {
    className: "list-table"
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("th", null, "\u0422\u0438\u043F"), ___EmotionJSX("th", null, "\u041F\u0440\u043E\u043C\u0435\u043D\u0438"))), ___EmotionJSX("tbody", null, history === null || history === void 0 ? void 0 : history.map(function (el) {
    var _ref3, _externalCreditHistor;

    return ___EmotionJSX("tr", {
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("td", null, moment(el === null || el === void 0 ? void 0 : el.created_at).isValid() ? moment(el === null || el === void 0 ? void 0 : el.created_at).format(dateTimeFormat) : 'N/A'), ___EmotionJSX("td", null, (_ref3 = (_externalCreditHistor = externalCreditHistoryTypeName[el === null || el === void 0 ? void 0 : el.type]) !== null && _externalCreditHistor !== void 0 ? _externalCreditHistor : el === null || el === void 0 ? void 0 : el.type) !== null && _ref3 !== void 0 ? _ref3 : '--'), ___EmotionJSX("td", null, formatHistoryData(el === null || el === void 0 ? void 0 : el.data)));
  }))) : ___EmotionJSX("p", null, "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0438\u0441\u0442\u043E\u0440\u0438\u044F")))));
};

ExternalCreditHistoryTab.propTypes = {
  history: PropTypes.array
};
export default ExternalCreditHistoryTab;